module.exports = __webpack_public_path__ + "static/media/info.1b9660ef.svg";